export default class SampleVehicleModelAvailabilityWriteDTO {

    public availabilityDate: string | undefined;
    public expirationDate: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.availabilityDate = data['availabilityDate'] || undefined;
        this.expirationDate = data['expirationDate'] || undefined;
    }
}